// extracted by mini-css-extract-plugin
export default {"two":"SecTwo_two__lGQTC","main":"SecTwo_main__-EUbI","text":"SecTwo_text__sSTBB","types":"SecTwo_types__HqA7x","type":"SecTwo_type__1rZOT","arrow":"SecTwo_arrow__zGOMU"};